export const PHRASE_SAVE = 'Save (move to Saved tab)';
export const PHRASE_NOTE_ADD = 'Add note';
export const PHRASE_NOTE_EDIT = 'Edit note';
export const PHRASE_MODIFY_CONTEXT = 'Modify context';
export const PHRASE_CONTEXT_ADD = 'Add context';
export const PHRASE_CONTEXT_REMOVE = 'Remove context';
export const PHRASE_DELETE_PHRASE = 'Delete phrase';
export const PHRASE_DELETE_ANNOTATION = 'Delete note';
export const PHRASE_PLAY_ORIGINAL = 'Play original';
export const PHRASE_SPEECH_PHRASE = 'Voiceover phrase';
export const PHRASE_SPEECH_NOTE = 'Voiceover';
